export const CookieRemove = (cookieName: string, cookieDomain?: string) => {
	const domain = cookieDomain ? `Path=/; Domain=${cookieDomain}; ` : '';

	document.cookie = `${cookieName}=;${domain}Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
